// src/components/MeshBackground.jsx
import React from 'react';

const MeshBackground = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-[#050505]">
      {/* Primary Glow */}
      <div className="absolute top-[-10%] left-[-10%] w-[70%] h-[70%] rounded-full bg-indigo-600/20 blur-[120px] animate-pulse" />
      
      {/* Secondary Accent */}
      <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] rounded-full bg-purple-600/10 blur-[100px]" 
           style={{ animation: 'float 20s infinite alternate' }} />
      
      {/* Kinetic Highlight */}
      <div className="absolute top-[20%] right-[10%] w-[30%] h-[30%] rounded-full bg-blue-500/10 blur-[80px]" />

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes float {
          0% { transform: translate(0, 0); }
          100% { transform: translate(-10%, 10%); }
        }
      `}} />
    </div>
  );
};

export default MeshBackground;